import { OverlayContainer } from '@angular/cdk/overlay';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { Router } from '@angular/router';
import { ItemMenu } from '@classes/models';
import { RechercheClient, RechercheClientData } from '@composants/composants';
import { Client, ClientsService, ControleperfService } from '@estel-numerique/galaclick-api';
import { CacheLowService } from '@estel-numerique/galaclick-core';
import { MonitoringService } from '@services/monitoring.service';
import { UtilService } from '@services/Util.service';
import { FileSaverService } from 'ngx-filesaver';
import { lastValueFrom } from 'rxjs';
import { AProposComponent } from '../apropos/apropos.component';
import { BilanSyntheseComponent } from '../bilansynthese/bilansynthese.component';
import { DatahubInitExportComponent } from '../datahub/datahub-initexport.component';
import { DocumentListeComponent } from '../document/pages/document-liste/document-liste.component';
import { FicheAnimalComponent } from '../ficheanimal/ficheAnimalModal';
import { FicheClientDetailsComponent } from '../ficheclient/pages/ficheclient-details/ficheclient-details.component';
import { IncarnationComponent } from '../incarnation/incarnation.component';
import { MassExportComponent } from '../massExport/massExport.component';
import { MonCompteComponent } from '../moncompte/moncompte.component';
import { PilotageComponent } from '../pilotage/pilotage.component';
import { PFClientMoveMultiComponent } from '../suiviagents/pfClientMoveMulti.component';
import { MatButton } from '@angular/material/button';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'menu-gala',
    templateUrl: './menu-gala.component.html',
    styleUrls: ['./menu-gala.component.scss'],
    imports: [MatButton, MatMenuTrigger, NgTemplateOutlet, MatMenu, MatMenuItem]
})
export class MenuGalaComponent {

    private util = inject(UtilService);
    private dialog = inject(MatDialog);
    protected router = inject(Router);
    private wsClient = inject(ClientsService);
    private translate = inject(TranslateService);
    private wsControlePerformances = inject(ControleperfService);
    private fileService = inject(FileSaverService);
    private datePipe = inject(DatePipe);
    private wsCacheLow = inject(CacheLowService);
    private overlayContainer = inject(OverlayContainer);

    @Input() public item: ItemMenu;
    @Output() opened = new EventEmitter();
    @ViewChild(MatMenuTrigger) protected menu: MatMenuTrigger;
    private monitoServ = inject(MonitoringService);
    protected ouvert() {
        this.opened.emit();
        /* on empeche le "backdrop" de bloquer le clic des autres boutons de menu */
        // utilisation d'un timeout pour s'assurer de la présence de l'élément dans le DOM
        setTimeout(() => {
            this.overlayContainer.getContainerElement().getElementsByClassName('cdk-overlay-backdrop').item(0)?.classList.add('hide-backdrop');
        }, 20);
    }

    public close() {
        this.menu?.closeMenu();
    }

    public clickItem(item: ItemMenu) {
        if (item.method) {
            //item.method();
            switch (item.method) {
                case 'FCTMONCOMPTE':
                    this.dialog.open(MonCompteComponent, { data: this.util.getUserSession() });
                    break;
                case 'FCTFICANIMAL':
                    this.dialog.open(FicheAnimalComponent);
                    break;
                case 'FCTPILOTAGE':
                    this.dialog.open(PilotageComponent);
                    break;
                case 'FCTPORTEFEUILLE':
                    this.dialog.open(PFClientMoveMultiComponent);
                    break;
                case 'FCTDOCELEVEURS':
                    this.dialog.open(DocumentListeComponent);
                    break;
                case 'FCTFICHECLIENT': {
                    const dialogRecherche = this.dialog.open(RechercheClient, { data: { horszone: true, fromClient: false } as RechercheClientData });
                    dialogRecherche.componentInstance.cheptel.subscribe((cheptel) => {
                        (async () => {
                            try {
                                this.util.showLoader();
                                const cl: Client = await lastValueFrom(this.wsClient.getClientByNuchep(cheptel.NUCHEP));
                                this.util.hideLoader();
                                if (cl != null) {
                                    this.util.hideLoader();
                                    this.openFicheClient(cl);
                                    dialogRecherche.close();
                                } else {
                                    this.util.showToastError(this.translate.instant("APPFICHECLIENT.ERRORNUCHEP"));
                                }
                            } catch (e) {
                                this.util.hideLoader();
                                throw e;
                            }
                        })().catch(e => this.util.fErreur(e));
                    });
                    break;
                }
                case 'FCTDOCBILAN': {
                    const dialogRechBilan = this.dialog.open(RechercheClient, { data: { horszone: true, fromClient: false } as RechercheClientData });
                    dialogRechBilan.componentInstance.cheptel.subscribe((cheptel) => {
                        this.dialog.open(BilanSyntheseComponent, { data: cheptel });
                        dialogRechBilan.close();
                    });
                    break;
                }
                case 'FCTDOCVALOLAIT': {
                    const dialogRechValolait = this.dialog.open(RechercheClient, { data: { horszone: true, fromClient: false } as RechercheClientData });
                    dialogRechValolait.componentInstance.cheptel.subscribe((cheptel) => {
                        if (cheptel) {
                            this.getBetriebeValolait(cheptel?.NUCHEP?.trim()).catch(e => this.util.fErreur(e));
                            dialogRechValolait.close();
                        }
                    });
                    break;
                }
                case 'FCTDATAHUB': {
                    const dialogRechClient = this.dialog.open(RechercheClient, { data: { horszone: true, fromClient: false } as RechercheClientData });
                    dialogRechClient.componentInstance.cheptel.subscribe((cheptel) => {
                        this.dialog.open(DatahubInitExportComponent, { data: { cheptel: cheptel } });
                        dialogRechClient.close();
                    });
                    break;
                }
                case 'FCTEXPORTMASSE':
                    this.dialog.open(MassExportComponent);
                    break;
                case 'FCTINCARNATION':
                    this.dialog.open(IncarnationComponent);
                    break;
                case 'DECO':
                    this.deco();
                    break;
                case 'APROPOS':
                    this.dialog.open(AProposComponent);
                    break;
                default: // Si qqu'un "bidouille" un lancement de fonction on déco d'office
                    this.deco();
            }
        }

        if (item.link != null && item.link != '#') {
            this.router.navigate([item.link]).catch(e => this.util.fErreur(e));
        }

        //on verifie qu'il y ai bien redirection avant de vider la recherche
        if (this.router.url != item.link) {
            this.util.fViderecherche();
        }
    }

    private async getBetriebeValolait(numeul: string) {
        this.util.showLoader();
        try {
            const betriebe = await lastValueFrom(this.wsControlePerformances.getBetriebeValolait(numeul, this.datePipe.transform(new Date(), 'yyyy-MM-dd'), true));
            this.fileService.save(this.util.convertBase64toBlob(betriebe.contenu, betriebe.type), betriebe.nom);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    openFicheClient(client: Client) {
        if (client) {
            this.dialog.open(FicheClientDetailsComponent, { data: client });
        }
    }

    private deco() {
        //notifier de la deconnexion
        this.clearCache();
        this.util.etatConnexion.next(false);
        this.monitoServ.unsetUser();
        this.util.ouvrirEcranAuth();
    }

    private clearCache() {
        sessionStorage.clear();
        this.wsCacheLow.clearCache();
    }
}

